const values = [
  { label: "Activo", value: 1 },
  { label: "Conciliado", value: 2 },
  { label: "Finalizado", value: 3 },
];

export default values;
